<template>
  <NuxtLink :to="switchLocalePath(alternateLocale.code)">
    {{ currentLocale.name }}
  </NuxtLink>
</template>

<script setup>
const { locale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()

const currentLocale = computed(() => {
  return locales.value.find((i) => i.code === locale.value)
})

const alternateLocale = computed(() => {
  return locales.value.find((i) => i.code !== locale.value)
})
</script>
